<div *ngIf="(activeStepIndex$ | async) !== undefined">
  <div *ngIf="cart$ | async as cart">
    <div class="cx-media">
      <div class="cx-list-media eb-cart-totals__mobile" *ngIf="cart?.totalItems && cart?.subTotal">
        {{ 'cartItems.cartTotal' | cxTranslate: { count: cart.totalItems } }}:
        {{ cart.totalPrice?.formattedValue || cart?.priceTotalValue?.formattedValue }}
      </div>
      <div *ngFor="let step of steps$ | async; let i = index">
        <div class="cx-list-media" *ngIf="i < activeStepIndex">
          <a
            [routerLink]="{ cxRoute: step.routeName } | cxUrl"
            class="eb-generic-page-stepper__link"
            [tabindex]="getTabIndex(i)"
            [innerHTML]="i + 1 + '. ' + (step.name | cxTranslate)"
            (click)="changeStep.emit(i)"
          >
            {{ i + 1 }}.
          </a>
        </div>
        <div class="cx-list-media is-active" *ngIf="i === activeStepIndex">
          <div>{{ i + 1 }}. {{ step.name | cxTranslate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
